<template>
  <div>
    <b-loading
        v-model="isLoading"
        :can-cancel="true"
        :is-full-page="true"
    ></b-loading>
    <b-modal v-model="modalActive" scroll="keep" width="90%">
      <div class="is-flex is-flex-direction-column" style="height: 100%;width: 100%">
        <div class="is-flex">
          <div class="block ml-auto mr-auto" v-if="type === 'video'">
            <b-radio v-model="selectedSpeed"
                     @input="onSpeedChanged"
                     type="is-white"
                     name="name"
                     class="mr-4"
                     :native-value="1">x1</b-radio>
            <b-radio v-model="selectedSpeed"
                     @input="onSpeedChanged"
                     type="is-white"
                     name="name"
                     class="mr-4"
                     :native-value="2">x2</b-radio>
            <b-radio v-model="selectedSpeed"
                     @input="onSpeedChanged"
                     type="is-white"
                     name="name"
                     class="mr-4"
                     :native-value="3">x3</b-radio>
            <b-radio v-model="selectedSpeed"
                     @input="onSpeedChanged"
                     type="is-white"
                     name="name"
                     class="mr-4"
                     :native-value="4">x4</b-radio>
            <b-radio v-model="selectedSpeed"
                     @input="onSpeedChanged"
                     type="is-white"
                     name="name"
                     :native-value="8">x8</b-radio>
          </div>
          <div class="block ml-auto mr-auto" v-else-if="type === 'image' && !isImageLoaded">
            <div class="has-text-grey-light">Please wait...</div>
          </div>
        </div>
        <video v-if="type === 'video'" id="vid" ref="videoRef"
               controls
               :src="src"
               @loadedmetadata="onVideoMetaDataLoaded" loop=""
               preload="auto"
               class="m-auto"
               muted="" style="height: 90%; min-width: 30vw; background: black"></video>

        <b-image
            v-else-if="type === 'image'"
            :src="src"
            @load="onImageLoaded"
            alt="Image"
        ></b-image>
      </div>

    </b-modal>
  </div>
</template>

<script>

export default {
  name: "preview-modal",
  components: {},
  data() {
    return {
      isLoading: false,
      modalActive: false,
      src: null,
      type: null,
      selectedSpeed: 1,
      isImageLoaded: false
    }
  },
  mounted() {},
  methods: {
    onSpeedChanged(speed){
      console.log('Speed changed: ', speed)
      this.$refs.videoRef.playbackRate = speed
    },
    onImageLoaded(event){
      console.log('On image loaded: ', event)
      this.isImageLoaded = true;
    },
    async show(show, url, type) {
      this.modalActive = show
      console.log('Preview data: ', url, type)
      console.log('Selected speed: ', this.selectedSpeed)

      this.type = type

      if(show){
        setTimeout(()=>{
          this.src = url
          if(this.type === 'video') {
            this.$refs.videoRef.playbackRate = this.selectedSpeed
          }else if(type === 'image'){
            console.log('Setup image here')
          }
        }, 1000)
      }else {
        this.type = null
        this.src = null
        this.selectedSpeed = 1
        this.isImageLoaded = false
      }
    },
    onVideoMetaDataLoaded(e) {
      this.isLoading = false
    },
    async onCloseClicked() {
      await this.show(false, null)
    },
  },
}
</script>

<style scoped lang="scss">

.b-radio.radio {
  color: white !important;
}
</style>